import { useQuery } from '@tanstack/react-query'
import { getAllUsers } from '../../../api/users/getAllUsers'

export const useGetAllUsers = (state: number) => {
  return useQuery({
    queryKey: ['allUsers', state],
    queryFn: () => getAllUsers(state === -1 ? 1 : state === -2 ? 0 : 1),
    staleTime: 1000 * 60 * 60,
    retry: 1
  })
}